var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 401,
    viewBox: "0 0 490 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.891 107.765L231.036 109.588L284.485 372.366L262.891 107.765Z",
    fill: "url(#paint0_linear_6_370)",
    fillOpacity: 0.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.805 101.88L235.577 98.2148L237.685 331.442L262.805 101.88Z",
    fill: "url(#paint1_linear_6_370)",
    fillOpacity: 0.17
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.322 102.233L253.798 111.318L368.676 243.303L272.322 102.233Z",
    fill: "url(#paint2_linear_6_370)",
    fillOpacity: 0.17
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.928 116.054L244.181 98.9896L123.792 232.441L254.928 116.054Z",
    fill: "url(#paint3_linear_6_370)",
    fillOpacity: 0.17
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.045 111.76L235.184 97.197L150.729 378.729L266.045 111.76Z",
    fill: "url(#paint4_linear_6_370)",
    fillOpacity: 0.17
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.756 95.2221L238.158 103.922L351.083 369.884L271.756 95.2221Z",
    fill: "url(#paint5_linear_6_370)",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_370",
    x: 207.026,
    y: 83.755,
    width: 101.469,
    height: 312.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6_370",
    x: 211.567,
    y: 74.2048,
    width: 75.2479,
    height: 281.247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6_370",
    x: 229.788,
    y: 78.2227,
    width: 162.898,
    height: 189.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6_370",
    x: 99.7822,
    y: 74.9796,
    width: 179.156,
    height: 181.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_6_370",
    x: 126.719,
    y: 73.187,
    width: 163.336,
    height: 329.552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_6_370",
    x: 214.148,
    y: 71.2121,
    width: 160.945,
    height: 322.682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.005,
    result: "effect1_foregroundBlur_6_370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_370",
    x1: 238.062,
    y1: 134.361,
    x2: 269.17,
    y2: 130.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_370",
    x1: 237.456,
    y1: 120.528,
    x2: 264.422,
    y2: 122.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_370",
    x1: 265.82,
    y1: 123.257,
    x2: 281.742,
    y2: 111.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_370",
    x1: 233.443,
    y1: 112.68,
    x2: 247.01,
    y2: 126.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_370",
    x1: 229.089,
    y1: 124.757,
    x2: 260.478,
    y2: 136.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_370",
    x1: 250.925,
    y1: 128.573,
    x2: 283.19,
    y2: 117.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterLight);
export default __webpack_public_path__ + "static/media/center-light.c7743ab7c7e6b06ae9f4300a6cedb9da.svg";
export { ForwardRef as ReactComponent };